import AssignmentMappingsViewModal from './AssignmentMappingsViewModal';

export default AssignmentMappingsViewModal;
